import React from "react";
import NavBar from "./components/NavBar";
import MainContent from "./components/MainContent";
import Footer from "./components/Footer";

export default function LandingPage(props) {
  return (
    <>
      <NavBar />
      <MainContent />
      <Footer />
    </>
  );
}
